import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import { 
  FaUsers, 
  FaCalendarAlt, 
  FaBullhorn, 
  FaChartLine, 
  FaCog, 
  FaPlus,
  FaEye,
  FaUserTie,
  FaMoneyBillWave,
  FaTasks
} from 'react-icons/fa'
import { AiOutlineArrowRight, AiOutlineNotification } from 'react-icons/ai'
import { useAuth } from '../../context/Auth'
import { toast } from 'react-toastify'
import Loading from '../../components/Loading/Loading'
import { useParams } from 'react-router-dom'

const GroupDashboard = () => {
  const groupId = localStorage.getItem('selectedGroupId')
    const [gettingDashboardData, setGettingDashboardData] = useState(true)
    const { requestWithAuth } = useAuth();
  const [groupStats, setGroupStats] = useState({
    total_members: 0,
    active_members: 0,
    total_executives: 0,
    monthly_contributions: 0,
    pending_tasks: 0,
    upcoming_events: 0
  })

  const [recentActivities] = useState([
    { id: 1, action: "New member joined", member: "John Doe", time: "2 hours ago" },
    { id: 2, action: "Executive meeting scheduled", member: "System", time: "5 hours ago" },
    { id: 3, action: "Monthly contribution received", member: "Jane Smith", time: "1 day ago" },
    { id: 4, action: "Announcement published", member: "You", time: "2 days ago" }
  ])

  const [upcomingEvents] = useState([
    { id: 1, title: "Monthly Executive Meeting", date: "2025-09-15", time: "10:00 AM" },
    { id: 2, title: "Community Outreach Program", date: "2025-09-20", time: "2:00 PM" },
    { id: 3, title: "Annual General Meeting", date: "2025-09-25", time: "9:00 AM" }
  ])

  const getDashboardData = async () => {
    
    try {
      const response = await requestWithAuth(`/group-leader/groups/${groupId}/dashboard/`, "GET");
      setGroupStats(response?.data?.group_stats);
    } catch (error) {
      toast.error("An error occurred while getting data");
    } finally {
        setGettingDashboardData(false);
    }
  };

  // Simulate data loading
  useEffect(() => {
    getDashboardData();
  }, [])

  const quickActions = [
    {
      title: "Add Member",
      icon: <FaPlus />,
      color: "bg-blue-500",
      action: () => console.log("Add member clicked")
    },
    {
      title: "Create Announcement",
      icon: <FaBullhorn />,
      color: "bg-green-500",
      action: () => console.log("Create announcement clicked")
    },
    {
      title: "Schedule Meeting",
      icon: <FaCalendarAlt />,
      color: "bg-purple-500",
      action: () => console.log("Schedule meeting clicked")
    },
    {
      title: "Manage Executives",
      icon: <FaUserTie />,
      color: "bg-orange-500",
      action: () => console.log("Manage executives clicked")
    }
  ]

  const StatCard = ({ title, value, icon, color, subtitle }) => (
    <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
        </div>
        <div className={`${color} p-3 rounded-full text-white`}>
          {icon}
        </div>
      </div>
    </div>
  )

  const QuickActionCard = ({ title, icon, color, action }) => (
    <button
      onClick={action}
      className={`${color} hover:opacity-90 text-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all flex items-center justify-center flex-col gap-2 min-h-[100px]`}
    >
      <div className="text-2xl">{icon}</div>
      <span className="text-sm font-medium text-center">{title}</span>
    </button>
  )

  if(gettingDashboardData){
    return <Loading />
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Welcome Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Welcome back! 👋
          </h2>
          <p className="text-gray-600">
            Here's what's happening with your group today.
          </p>
        </div>

        {/* Stats Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatCard
            title="Total Members"
            value={groupStats?.total_members}
            icon={<FaUsers />}
            color="bg-blue-500"
            subtitle={`${groupStats?.active_members} active`}
          />
          <StatCard
            title="Executives"
            value={groupStats?.total_executives}
            icon={<FaUserTie />}
            color="bg-purple-500"
            subtitle="Current positions"
          />
          <StatCard
            title="Monthly Contributions"
            value={`GHS ${groupStats?.monthly_contributions.toLocaleString()}`}
            icon={<FaMoneyBillWave />}
            color="bg-green-500"
            subtitle="This month"
          />
          <StatCard
            title="Pending Tasks"
            value={groupStats?.pending_tasks}
            icon={<FaTasks />}
            color="bg-orange-500"
            subtitle="Need attention"
          />
        </div>

        {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Quick Actions
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {quickActions.map((action, index) => (
                  <QuickActionCard
                    key={index}
                    title={action.title}
                    icon={action.icon}
                    color={action.color}
                    action={action.action}
                  />
                ))}
              </div>
            </div>
          </div>

          
          <div className="lg:col-span-2 space-y-6">
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Recent Activities
                </h3>
                <button className="text-blue-500 hover:text-blue-600 text-sm font-medium flex items-center gap-1">
                  View All <AiOutlineArrowRight />
                </button>
              </div>
              <div className="space-y-3">
                {recentActivities.map((activity) => (
                  <div key={activity.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <p className="text-sm font-medium text-gray-900">{activity.action}</p>
                      <p className="text-xs text-gray-500">by {activity.member}</p>
                    </div>
                    <span className="text-xs text-gray-400">{activity.time}</span>
                  </div>
                ))}
              </div>
            </div>

            
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Upcoming Events
                </h3>
                <button className="text-blue-500 hover:text-blue-600 text-sm font-medium flex items-center gap-1">
                  <FaPlus className="text-xs" /> Add Event
                </button>
              </div>
              <div className="space-y-3">
                {upcomingEvents.map((event) => (
                  <div key={event.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
                    <div className="flex items-center gap-3">
                      <div className="bg-blue-100 p-2 rounded-lg">
                        <FaCalendarAlt className="text-blue-500 text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">{event.title}</p>
                        <p className="text-xs text-gray-500">{event.date} at {event.time}</p>
                      </div>
                    </div>
                    <button className="text-gray-400 hover:text-gray-600">
                      <FaEye />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        
        <div className="mt-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Management Shortcuts
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <button className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                <FaUsers className="text-blue-500" />
                <div className="text-left">
                  <p className="font-medium text-gray-900">Member Management</p>
                  <p className="text-sm text-gray-500">View and manage all members</p>
                </div>
              </button>
              <button className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                <FaChartLine className="text-green-500" />
                <div className="text-left">
                  <p className="font-medium text-gray-900">Analytics & Reports</p>
                  <p className="text-sm text-gray-500">View group performance</p>
                </div>
              </button>
              <button className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                <FaCog className="text-gray-500" />
                <div className="text-left">
                  <p className="font-medium text-gray-900">Group Settings</p>
                  <p className="text-sm text-gray-500">Configure group preferences</p>
                </div>
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default GroupDashboard